import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import async from 'async'

import InspectionItem from '../InspectionItem'
// Constants
import {
  API_URL,
  FILE_STORAGE,
  FILE_STORAGE_API
} from '../../../../constants'
import Gallery from '../../../../shared/components/Gallery'
import Dropzone from '../../../../shared/components/Dropzone'
import Confirm from '../../../../shared/components/Confirm'
import Portal from '../../../../shared/components/Portal'
import RemoveButton from '../../../../shared/elements/removeButton'
import {
  uploadFileToOrder,
  deleteFileFromOrder
} from '../../../../actions/orders'
import { translation } from '../../../../utils/helpers'

class Files extends PureComponent {

  constructor (props) {
    super(props)
    this.state = {
      upload: {
        errors: []
      },
      order: {},
      loading: false,
      confirmFileDelete: {
        confirm: false,
        file: null
      },
      mounted: false
    }
    this.renderContent = this.renderContent.bind(this)
  }

  componentDidMount () {
    this.setState({
      upload: this.props.upload,
      order: this.props.order,
      loading: false,
      confirmFileDelete: {
        confirm: false,
        file: null
      },
      mounted: true
    })
  }
  componentWillReceiveProps (nextProps) {
    this.setState({
      upload: nextProps.upload,
      order: nextProps.order,
      loading: false,
      confirmFileDelete: {
        confirm: false,
        file: null
      },
      mounted: true
    })
  }
  componentWillUnmount () {
    this.setState({
      mounted: false
    })
  }

  renderContent () {
    if (typeof this.props.order.Id === 'undefined' || this.props.order.length === 0 || !this.state.mounted) return null
    let { errors } = this.state.upload
    // Delete file
    const deleteFile = (file) => {
      let confirm = {
        confirm: true,
        file: file
      }
      this.setState({
        confirmFileDelete: confirm
      })
    }

    // Render image
    const renderImage = (image, index) => {
      // console.log('RenderImage ', image)
      let url = FILE_STORAGE + image.ThumbURL
      let fullUrl = FILE_STORAGE + image.FileURL
      return (
        <div key={index} className='file-image'>
          <a href={fullUrl} data-lightbox='gallery' data-title={image.FileName}><img src={url} /></a>
          {image.IsDeletable && <div className='file-delete'><RemoveButton onClick={() => deleteFile(image)} size='s' /></div>}
        </div>
      )
    }
    // Render file
    const renderFile = (file, index) => {
      // let fileUrl = file.FileURL.replace('API/', '')
      if (file.ActualFileName === null) return null
      let newFileUrl = FILE_STORAGE_API + '/FileService/DownloadNoHeader?fileName=' + file.FileNameWithFolders + '&token=' + encodeURIComponent(this.props.auth.user.Token)
      let thumbUrl = API_URL + '/FileService/GetIcon?fileName=' + file.FileName
      const fileError = () => {
        window.toastr.error(translation('15191'), translation('216'))
      }
      return (
        <div key={index} className='file-document clearfix'>
          <img className='file-icon' alt='icon' src={thumbUrl} />
          {file.FileExists ? (<a target='_BLANK' href={newFileUrl}>
            {file.FileName}
          </a>) : (
            <a onClick={fileError}>
              {file.FileName}
            </a>
          )}
          {(this.props.auth.user.CustomerId === '-1' && file.IsDeletable) && <div className='file-delete'><RemoveButton onClick={() => deleteFile(file)} size='s' /></div>}
        </div>
      )
    }
    // On drop
    const onDrop = () => {
      this.setState({ upload: { ...this.state.upload, errors: [] } })
    }

    // On drop accepted
    const onDropAccepted = (files) => {
      let newErrors = []
      this.setState({
        upload: {
          ...this.state.upload,
          loading: true,
          errors: []
        }
      })
      async.each(files, (file, cb) => {
        // Upload each file
        this.props.uploadFileToOrder(file, this.props.order.Id).then((res) => {
          cb()
        }, () => {
          newErrors.push(translation('1207') + ': ' + file.name + ' ' + translation('13406') + '.')
          cb()
        })
      }, () => {
        if (newErrors.length !== 0) {
          this.setState({
            upload: {
              ...this.state.upload,
              errors: this.state.upload.errors.concat(newErrors)
            }
          })
        }
        this.setState({
          upload: {
            ...this.state.upload,
            loading: false
          }
        })
        // Save order first
        this.props.loadOrder()
      })
    }
    // On drop rejected
    const onDropRejected = (files) => {
      let newErrors = []
      files.map((val, index) => {
        newErrors.push(translation('1207') + ': ' + val.name + ' ' + translation('13405') + '.')
      })
      this.setState({ upload: { ...this.state.upload, errors: newErrors } })
    }
    // Render error
    const renderError = (error, index) => {
      return <p key={index}>{error}</p>
    }
    // Other files
    let otherFiles = []
    let imgFiles = []
    if (this.state.order.OrderFiles !== undefined) {
      otherFiles = [...this.state.order.OrderFiles]
      otherFiles = otherFiles.filter((val, index) => {
        return !val.IsImage
      })
      // imgFiles
      imgFiles = [...this.state.order.OrderFiles]
      imgFiles = imgFiles.filter((val, index) => {
        return val.IsImage
      })
    }

    // Confirm delete
    const onPortalClose = () => {
      let confirm = {
        confirm: false,
        file: null
      }
      this.setState({
        confirmFileDelete: confirm
      })
    }
    const onConfirm = () => {
      let file = this.state.confirmFileDelete.file
      let confirm = {
        confirm: false,
        file: null
      }
      this.setState({
        confirmFileDelete: confirm
      }, () => {
        let newErrors = []
        this.props.deleteFileFromOrder(file).then((res) => {
          this.props.loadOrder()
        }, () => {
          newErrors.push(translation('1207') + ': ' + file.FileName + '' + translation('13406') + '.')
          this.setState({
            upload: { ...this.state.upload, errors: newErrors }
          })
        })
      })
    }

    // Render
    let isMultipleUpload = true
    return (
      <div className=''>
        {errors.length !== 0 && <div className='alert alert-danger'>{errors.map(renderError)}</div>}
        <Dropzone
          onDrop={onDrop}
          onDropAccepted={onDropAccepted}
          onDropRejected={onDropRejected}
          multiple={isMultipleUpload}
          includeCircles={false}>
          {this.state.upload.loading && (
            <p className='loading'>
              <span className='animated-background'>
                <i className='fa fa-spinner fa-spin fa-3x fa-fw' />
                <span className='sr-only'>{translation('13382')}...</span>
              </span>
            </p>
          )}
          {!this.state.upload.loading && (
            <p>{translation('13397')}</p>
          )}
        </Dropzone>
        <div className='files_inner'>
          <div>
            {otherFiles.map(renderFile)}
          </div>
          <Gallery files={imgFiles} renderImage={renderImage} />
        </div>
        {this.state.confirmFileDelete.confirm && (
          <Portal className='deleteModal' onPortalClose={onPortalClose}>
            <Confirm confirm={onConfirm} notConfirm={onPortalClose} />
          </Portal>
        )}
      </div>
    )
  }
  render () {
    if (!this.props.order.OrderFiles) return null
    let title = {
      icon: '/images/svgs/inspection/files.svg',
      text: '1043'
    }
    const headerClick = () => { }
    return (
      <InspectionItem title={title} renderContent={this.renderContent} onHeaderClick={headerClick} showCheckmark={false} />
    )
  }
}

Files.defaultProps = {
  isBodyshop: false,
  upload: {
    errors: []
  }
}

Files.propTypes = {
  loadOrder: PropTypes.func.isRequired,
  isBodyshop: PropTypes.bool,
  upload: PropTypes.object,
  order: PropTypes.object.isRequired
}

Files.contextTypes = {
  router: PropTypes.object.isRequired
  // t: React.PropTypes.func.isRequired,
  // enum: React.PropTypes.func.isRequired
}
function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}
export default connect(mapStateToProps, {
  uploadFileToOrder,
  deleteFileFromOrder
})(Files)



// WEBPACK FOOTER //
// ./src/app/pages/Orders/OrderInspection/Files/index.js